"use strict";

module.exports = {
  strings: {
    pluginNameZoom: 'Zoom'
  }
};